import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M13.873 3.067a.7.7 0 0 1 .38.805L12.9 9.225h4.351a.7.7 0 0 1 .585 1.085L11.01 20.685a.7.7 0 0 1-1.27-.533l1.392-6.415H6.75a.7.7 0 0 1-.565-1.113l6.825-9.337a.7.7 0 0 1 .863-.22Zm-5.744 9.27H12a.7.7 0 0 1 .684.849l-.778 3.59 4.046-6.151H12a.7.7 0 0 1-.679-.872l.69-2.728-3.882 5.313Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
